import { makeStyles } from '@material-ui/core/styles';
import { withTheme } from '@material-ui/core/styles';
import React, { useState } from 'react';
import Table, { CELL_TYPES, FILTER_TYPES } from 'mui-advanced-table';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Slider from '@material-ui/core/Slider';
import BusinessIcon from '@material-ui/icons/BusinessSharp';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';

const ThemedTable = withTheme(Table);

const useStyles = makeStyles((theme) => ({
  tableSize: {
    width: '100vw',
    height: '100vh',
  },
  rowHover: {
    backgroundColor: 'red',
  },
  sliderCell: {
    overflow: 'visible',
  },
  expansionCard: {
    margin: theme.spacing(1.6),
    width: 'auto',
    height: `calc(100% - ${theme.spacing(3.2)})`,
    borderRadius: 0,
    backgroundColor: `${theme.palette.background.paper} !important`,
    padding: theme.spacing(1.6),
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  customStyles: {
    color: theme.palette.error.dark,
    backgroundColor: '#aaa',
  }
}));

const CustomCellType = ({ className, style }) => {
  const classList = useStyles();
  return (
    <div className={clsx(className, classList.sliderCell)} style={style}>
      <Slider
        defaultValue={50}
        valueLabelDisplay="auto"
        step={1}
        min={0}
        max={100}
      />
    </div>
  );
}

const ExpandedRow = ({ style, className, rowData }) => {
  const classeList = useStyles();
  return (
    <div style={style} className={className}>
      <Card elevation={2} className={classeList.expansionCard}>
        <Typography variant="h4">{`Expanded data for row ${rowData.index}`}</Typography>
      </Card>
    </div>
  );
}

const makeRow = (checkbox, pickDate, textField, count, date, floatInput, integerInput, dropdown, text, currencyInput, currency, status, custom, iconButton, customStyles) => ({
  checkbox,
  pickDate,
  textField,
  count,
  date,
  floatInput,
  integerInput,
  dropdown,
  text,
  currencyInput,
  currency,
  status,
  custom,
  iconButton,
  customStyles
});

//From https://gist.github.com/miguelmota/5b67e03845d840c949c4
const getRandomDate = (start, end) => {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())).toISOString();
}

const testingRows = [];
for (let i = 0; i < 1500; i++) {
  let status = i % 3;
  status = status === 0 ? 'complete' : status;
  status = status === 1 ? 'pending' : status;
  status = status === 2 ? 'error' : status;

  const randomDate = getRandomDate(new Date(2000, 0, 1), new Date());
  testingRows.push(makeRow(
    false,
    '',
    'asdf',
    10,
    randomDate,
    i,
    i,
    '',
    'Cool kids',
    i / 14,
    i / 4,
    status,
    '',
    '',
    'Passed in styles'
  ));
}

const makeTestingColumns = actions => (
  [{
    width: 54,
    label: '',
    dataKey: 'checkbox',
    type: CELL_TYPES.CHECKBOX,
    inputAction: actions.checkbox,
    sortable: false,
  }, {
    width: 90,
    label: 'Button',
    dataKey: 'iconButton',
    type: CELL_TYPES.ACTION_BUTTON,
    cellProps: {
      icon: <BusinessIcon />,
      buttonColor: '#f72103'
    }
  }, {
    flex: 2,
    minWidth: 175,
    maxWidth: 300,
    label: 'Date Picker',
    dataKey: 'pickDate',
    type: CELL_TYPES.DATE_INPUT,
    inputAction: actions.pickDate,
  }, {
    flex: 1,
    minWidth: 150,
    label: 'Input Field',
    dataKey: 'textField',
    inputAction: actions.textField,
    type: CELL_TYPES.TEXT_INPUT,
    sortable: true,
    draggable: true,
    filter: {
      type: FILTER_TYPES.TEXT
    }
  }, {
    flex: 1,
    minWidth: 125,
    label: 'Date',
    dataKey: 'date',
    type: CELL_TYPES.DATE,
    sortable: true,
    draggable: true,
    filter: {
      type: FILTER_TYPES.DATE
    }
  }, {
    flex: 1.5,
    minWidth: 165,
    label: 'Cast to Float',
    dataKey: 'floatInput',
    type: CELL_TYPES.NUMBER_INPUT,
    inputAction: actions.floatInput,
    sortable: true,
    draggable: true,
    totalable: true,
  }, {
    flex: 1.5,
    minWidth: 170,
    label: 'Integers Only',
    dataKey: 'integerInput',
    type: CELL_TYPES.TEXT_INPUT,
    inputAction: actions.integerInput,
    sortable: true,
    draggable: true,
    totalable: true,
    cellProps: {
      validators: [
        //Validate an integer
        (val) => {
          const castToNum = Number(val);
          const storedInt = parseInt(castToNum);
          const displayVal = storedInt;
          const isError = Number.isNaN(storedInt) || (castToNum !== storedInt);
          return [storedInt, displayVal, isError];
        }
      ]
    }
  }, {
    flex: 1.5,
    minWidth: 150,
    label: 'Dropdown',
    dataKey: 'dropdown',
    type: CELL_TYPES.DROPDOWN,
    inputAction: actions.dropdown,
    cellProps: {
      choices: ['One', 'Two', 'Three'],
      placeholder: 'choose...',
      allowMultiple: true,
    },
    draggable: true,
    sortable: true,
  }, {
    width: 125,
    label: 'Undef Data',
    dataKey: 'noData',
    type: CELL_TYPES.TEXT,
  }, {
    flex: 1.5,
    minWidth: 190,
    label: 'Currency Input',
    dataKey: 'currencyInput',
    type: CELL_TYPES.CURRENCY_INPUT,
    inputAction: actions.currencyInput,
    sortable: true,
    draggable: true,
    totalable: true,
  }, {
    flex: 1.5,
    label: 'Currency',
    dataKey: 'currency',
    type: CELL_TYPES.CURRENCY,
    minWidth: 100,
    draggable: true,
  }, {
    minWidth: 150,
    label: 'Count',
    dataKey: 'count',
    type: CELL_TYPES.NUMBER,
    totalable: true,
    draggable: true,
    sortable: true,
  }, {
    width: 110,
    label: 'Status',
    dataKey: 'status',
    type: CELL_TYPES.STATUS,
    draggable: true,
    sortable: true,
    filter: {
      type: FILTER_TYPES.DROPDOWN,
      choices: {
        'Pending': 'PENDING',
        'Incomplete': 'false',
        'Complete': 'true'
      }
    }
  }, {
    flex: 2,
    minWidth: 200,
    label: 'Custom Cell Type',
    dataKey: 'custom',
    type: <CustomCellType />,
    draggable: true,
  }, {
    minWidth: 250,
    label: 'Styled /w Classes API',
    dataKey: 'customStyles',
    type: CELL_TYPES.TEXT,
    draggable: true,
  }, {
    flex: 2,
    minWidth: 250,
    label: 'Plain Text',
    dataKey: 'text',
    type: CELL_TYPES.TEXT,
    draggable: true,
  }]
);

const TableTesting = () => {
  const classList = useStyles();
  const [rows, setRows] = useState(testingRows);

  const updateRowProperty = propName => (data, rowData) => {
    testingRows[rowData.index] = {
      ...testingRows[rowData.index],
      [propName]: data
    };
  }

  const classes = {
    cellInColumn: {
      customStyles: classList.customStyles
    }
  }

  const actions = {
    checkbox: updateRowProperty('checkbox'),
    pickDate: updateRowProperty('pickDate'),
    textField: updateRowProperty('textField'),
    floatInput: updateRowProperty('floatInput'),
    integerInput: updateRowProperty('integerInput'),
    currencyInput: updateRowProperty('currencyInput'),
    dropdown: updateRowProperty('dropdown')
  };

  const columns = makeTestingColumns(actions);

  return (
    <ThemedTable
      columns={columns}
      rows={testingRows}
      title="This Table Has Every Feature"
      size="large"
      totalsLabel="TOTALS"
      classes={classes}
      className={classList.tableSize}
      expandedRowHeight={256}
      expandedRowElement={<ExpandedRow />}
    />
  );
};

TableTesting.defaultProps = {};

TableTesting.propTypes = {};

export default TableTesting;